import { TKeys } from "./types";

export const tr_tr: Record<TKeys, string> = {
    ...require('./en-en').en_en, // TODO
    // SCREENS    
    // General
    loading: 'Yükleniyor...',
    // SignIn
    signin_title: 'Giriş yap',
    signin_redirect_title: 'Giriş bilgilerini doğrula',
    psw_placeholder_redirect: "Parolanı onayla",
    psw_placeholder: 'Parola gir',
    email_placeholder: 'E-posta adresi',
    language: 'Dil',
    forgot_password: 'Parolanı unuttunuz?',
    signup_hint: 'Hesabınız yok mu? Kaydol',
    btn_signin: 'Giriş yap',
    // Intro
    // N-Ary sort
    my_profile: 'Tercihlerim',
    btn_submit: 'Gönder',
    btn_finish: 'Bitir',
    hint_undo: 'Son eyleminizi geri almak istiyormusunuz?',
    // Global screen
    tip_quit: 'Çıkarmak istiyormusunuz?',
    // State screen // Tell us, what is your ideal work environment?
    intro_title: 'Mutluluk, başarıın anahtarıdır',
    intro_body: `Yaptığınız şeyleri seviyor ve çalıştığınız ekiple, profesyonel hayatınızda başarılı olacaksınız`,
    howto1_title: `2 deklarasyon göreceksiniz
    
    Favori olanını tıklatın

    Bu sadece 12 dakika alacak`,
    howto1_body: 'Bu testi sessiz bir ortamda alın.',
    award1_title: 'İyi iş!',
    award1_body: `Aşağıdaki listenin üstünde, ideal çalışma ortamınızda en önemli şeyleri bulacaksınız. İstediğiniz gibi, deklarasyonları sürükleyip bırakarak sıralamayı değiştirebilirsiniz.`,
    award2_title: 'Yarım yolda daha fazla!',
    award2_body: `Bu listenin üstünde en önemli deklarasyonlarınız var. Kalbinizin istediklerini sürükleyip bırakarak, heyecanını hissedin Rüyalarınızın çalışma alanı, sadece bir hareket uzakta!`,
    award3_title: 'Üçüncü bölüm için kutlama',
    award3_body: `Sizin neredeyse orada Bitiş hattı göz önünde Son anlarda derin bir nefes al, her şeyi verin ve sizi bekleyen muhteşem başarının kutlanmasını bekleyin. Bunu yapın Güçlü bir bitiş ve başarı hikâyesinin açılması için izin verin!`,
    howto2_title: 'Ve son sorular - ±2 dakika',
    howto2_body: `Birkaç daha soru sorulacak. Bazı deklarasyonları zaten sıraladığınızdan, en iyi veya en kötü olanını seçmek zorunda kalacaksınız. Bu, sizin kişiliğinizi üç turunu birleştirmemizi sağlar`,
    title_rank: '**IDEAL** çalışma ortamimde,',
    subtitle_rank_2: 'En önemli şey ...',
    subtitle_rank_n: 'Aşağıdaki deklarasyonu nerede yerleştireceksiniz?',
    hint_reorder: 'Gerekirse, en önemli şeylerden en az önemli şeylere sıralama',
    hint_overview: 'Aşağıdaki bağlantıyı tıklatın ve özetini görüntüle',
    hint_profile: 'Şu anki tercihlerim',
    hint_place_below: 'Aşağıdaki deklarasyonu yerleştirelim',
    title_rank_bucket: 'Son karşılaştırmalar',
    subtitle_rank_best: 'Bu sefer, size en önemli olanı hangisi?',
    subtitle_rank_least: 'Size en az önemli olanı hangisi?',
    subtitle_rank_reorder: 'En önemli şeylerden en az önemli şeylere sıralama',
    title_thanks: 'İyi iş!',
    hint_thanks: 'Tercihleriniz başarıyla gönderildi',
    title_error: 'Verilerinizi gönderemeziz',
    hint_error: 'Lütfen daha sonra tekrar deneyin ...',
    hint_error_validation: 'Doğrulama hatası oluştu, lütfen daha sonra tekrar deneyin', // FIXME
    hint_error_dup: 'Önceki raporu zaten gönderdiniz.',
    hint_confirm_round: 'Bu sıralamayı onaylamak istediğinizden emin misiniz?',
    retry_btn: 'Tekrar deneyin',
    btn_to_overview: 'Genel Bakış',
    btn_to_bucket_x: 'Kutu',
    btn_to_params: 'Parametreler',
    btn_open: 'Açık',
    btn_start: 'Başlat',
    btn_confirm: 'Onayla',
    // btn_next: 'NEXT',
    btn_next: '>',
    btn_next_str: 'Sonraki',
    btn_next_round: 'Sonraki Tur',
    // btn_prev: 'PREV',
    btn_prev: '<',
    btn_cancel: 'İptal',
    // btn_back: 'BACK',
    btn_back: '<',
    btn_download: 'Raporunu indir',
    btn_quit: 'Çık',
    // Comparisons
    pick_best: 'Size en önemli olanı hangisi?',
    pick_worst: 'Size en az önemli olanı hangisi?',
    vs: 'YA',
    // UI elements
    round: 'Tur',
    stm: 'Beyanlar',
    bucket: 'Kutu',
    axis_y: 'beyan sayısı',
    tip_saved: 'Kaydedildi',
    top_scale_hint: '**En önemli**',
    bottom_scale_hint: '**En az önemli**',
    pick_tip: 'Seçildi!',
    how_to_binary_title: 'Talimatlar',
    // values
    samen: 'İş birliği',
    conf: 'Uygunluk',
    erken: 'Takdir',
    zorg: 'İlgi',
    gelijk: 'Eşitlik ve çeşitlilik',
    zelfsturing: 'Özerklik',
    macht: 'Güç',
    voorspelbaar: 'Tahmin edilebilirlik',
    prestatie: 'Performans',
    zelfontplooi: 'Kişisel gelişim',
    duurzaam: 'Sürdürülebilirlik',
    integriteit: 'Dürüstlük',
    innovatie: 'İnovasyon',
    daadkracht: 'Güç',
    // 
    no_slug_error: 'Lütfen doğru bağlantıyı takip ettiğinizden emin olun, eğer öyleyse yönetici/destek ile iletişime geçin',
    unknown_error: 'Bilinmeyen bir hata oluştu, lütfen daha sonra tekrar deneyin',
    invalid_credentials: 'Geçersiz e-posta / şifre kombinasyonu',
    // 360:
    // TLTM Scale
    lvl0: 'Lütfen seçin',
    lvl1: 'Çok çok az',
    lvl2: 'Çok az',
    lvl3: 'Biraz çok az',
    lvl4: 'Doğru Miktar',
    lvl5: 'Biraz çok',
    lvl6: 'Çok',
    lvl7: 'Çok çok fazla',
    lvlx1: '-3',
    lvlx2: '-2',
    lvlx3: '-1',
    lvlx4: 'Doğru Miktar',
    lvlx5: '+1',
    lvlx6: '+2',
    lvlx7: '+3',
    // SCALE 10 lvlSC10x
    lvlSC10x00: 'Lütfen seçin',
    lvlSC10x00e: '🤔',
    //
    lvlSC10x0e: '😫',
    lvlSC10x0nps: 'Asla',
    lvlSC10x0: 'Boş',
    lvlSC10x1e: '😖',
    lvlSC10x1nps: 'MISSING',
    lvlSC10x1: 'Çok çok kötü',
    lvlSC10x2e: '😣',
    lvlSC10x2nps: 'MISSING',
    lvlSC10x2: 'Çok kötü',
    lvlSC10x3e: '😠',
    lvlSC10x3nps: 'MISSING',
    lvlSC10x3: 'Kötü',
    lvlSC10x4e: '🙁',
    lvlSC10x4nps: 'MISSING',
    lvlSC10x4: 'Yetersiz',
    lvlSC10x5e: '😯',
    lvlSC10x5nps: 'MISSING',
    lvlSC10x5: 'Vasat',
    lvlSC10x6e: '😐',
    lvlSC10x6nps: 'MISSING',
    lvlSC10x6: 'Orta',
    lvlSC10x7e: '🙂',
    lvlSC10x7nps: 'MISSING',
    lvlSC10x7: 'İyi',
    lvlSC10x8e: '😊',
    lvlSC10x8nps: 'MISSING',
    lvlSC10x8: 'Çok iyi',
    lvlSC10x9e: '😃',
    lvlSC10x9nps: 'MISSING',
    lvlSC10x9: 'Mükemmel',
    lvlSC10x10e: '😍',
    lvlSC10x10nps: 'Kesinlikle',
    lvlSC10x10: 'Açıkça mükemmel',
    howto_360_title: `Bir kuruluş olarak, değerlere büyük önem veriyoruz ve çalışma ortamınızda sizi gerçekten mutlu eden şeyleri bilmenin önemli olduğuna inanıyoruz.`,
    howto_360_body: `Bu anket, yönetiminize yalnızca toplu sonuçları iletecek şekilde anonim kalacaktır`,
    picker_360_title_workenv: "Mevcut çalışma ortamımda",
    picker_360_title_leadership: "Direkt yöneticim",
    nps_title: "Burada çalışmayı tanıdığınız birine önerir misiniz?",
    comment_title: 'Yorum ekleyin',
    comment_placeholder: 'Bu deklarasyon için herhangi bir yapısal geri bildirim için teşekkür ederiz',
    comment_save: 'Kaydet ve kapat',
    comment_remaining: 'character(s) left',
    howto_workenv_title: 'And now, your work environment',
    howto_workenv_body: 'What about it ? Last questions, we promise!',
    howto_nps_title: "",
    howto_nps_body: "",
    // legacy_v2:
    btn_next_step: 'Sonraki',
    to_assign: 'Atanacak',
    least_important: 'En az önemli',
    moderately_important: 'Orta derecede önemli',
    most_important: 'En önemli',
    ranker_title: 'İdeal işinde senin için ne önemli?',
    too_insufficient_warning: 'Bu grup yetersiz ifade içeriyor',
    too_much_warning: 'Bu grup çok fazla ifade içeriyor',
    too_much_warning1: 'Aşağıdaki grup(lar)a fazla ifade atadınız:',
    too_much_warning2: 'Gruba tıklayın ve ifadeleri başka bir gruba atayın, dağılım doğru olana kadar',
    empty_bin: 'Bu grup boş',
    // further_ranking: 'Lütfen "{{v2}}" olarak işaretlediğiniz {{v1}} ifadelerini daha ayrıntılı olarak sıralayın',
    further_ranking: 'İdeal işinde senin için ne önemli?',
    hint_modal_title: 'İdeal çalışma ortamınızı hayal edin',
    hint_modal_body1: 'İdeal ortamınız hakkında 42 ifadeyi en az önemliden en önemliye sıralayın',
    hint_modal_body2_left: 'sol',
    hint_modal_body2_left_txt: 'en az önemli bulduğunuz 11 ifade',
    hint_modal_body2_right: 'sağ',
    hint_modal_body2_right_txt: 'en önemli bulduğunuz 11 ifade',
    hint_modal_body2_middle: 'orta',
    hint_modal_body2_middle_txt: 'orta derecede önemli bulduğunuz 20 ifade',
    hint_modal_body3: 'Her ifadeyi size en uygun gruba sürükleyip bırakın',
    hint_modal_cta: 'Başlat',
    hint_top: 'Yukarı kaydır',
    hint_down: 'Aşağı kaydır',
    final_distribution_invalid_title: 'Son dağılım geçersiz',
    final_distribution_invalid_body: 'Çok fazla ifade içeren {{v1}} kutu var ve çok az ifade içeren {{v2}} kutu var',
    no_available_bins_warning: 'Rastgele atama için uygun kutu yok - tüm kutular maksimum kapasitelerine ulaştı',
    sort_middle_bucket_title: 'Orta kutuyu sıralamak ister misiniz?',
    sort_middle_bucket_body: 'Bu, orta kutuyu değere göre sıralayacaktır.',
    reflect_current_view_title: 'Bu mevcut görüşünüzü yansıtıyor mu?',
    reflect_current_view_sort_body: 'Değilse, son sıralamanızı sıralamanız teklif edilecektir',
    yes: 'Evet',
    no: 'Hayır',
    final_ranking: 'Son Sıralama',
    example: 'Örnek :',
}